import { configureStore } from '@reduxjs/toolkit';

import adminAuthReducer from './adminAuth';
import assetDataReducer from './assets';
import orderFilters from './orderFilters';
import userFilters from './userFilters';

export const store = configureStore({
  reducer: {
    adminAuth: adminAuthReducer,
    assetData: assetDataReducer,
    orderFilters: orderFilters,
    userFilters: userFilters
  },
});

export default store;